import React from "react";
import { StyledButton } from "../styles/styledComponents";

type ButtonProps = {
  text: string;
    disabled: boolean;
    hidden: boolean;
  type?: string;
  onClick: () => any;
};

const Button = (props: ButtonProps) => {
  const { text, disabled, type, onClick, hidden } = props;

  return ( hidden ? 
    <StyledButton typeof={type} disabled={disabled} onClick={onClick()}>
      {text}
    </StyledButton> : null
  );
};

export default Button;
